<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import resizeImage from "$lib/utils/resizeImage";
  import { aspectRatio } from "$lib/utils/optimizeImage";
  import PostCardSubheading from "$lib/molecules/newsroom/helper/PostCardSubheading.svelte";
  import { parseUrl } from "$lib/utils/helpers";
  import { slide } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  export let post: any;
  export let isLast: boolean;
  let isExternalLink = post?.content?.externalLink?.url?.length > 0;
  let hovered = false;
</script>

{#if post && post.full_slug}
  <div
    class={`${isLast ? "" : "mb-8 pb-8 sm:mb-[2%] sm:pb-[2%]"}`}
    style={`${isLast ? "" : "border-bottom:1px solid rgb(221, 220, 218)"}`}
  >
    <a
      href={post?.content?.externalLink?.url || "/" + parseUrl(post.full_slug)}
      target={isExternalLink ? "_blank" : ""}
      rel={isExternalLink ? "noopener noreferrer" : ""}
      class={`group flex flex-col sm:flex-row lg:!p-0 justify-between items-center gap-6 w-full border-top text-charcoal no-underline px-0`}
      on:mouseenter={() => {
        hovered = true;
      }}
      on:mouseleave={() => {
        hovered = false;
      }}
    >
      <div class="space-y-[.8rem] lg:max-w-[50%] w-full">
        <PostCardSubheading {post} type="inline-post-card" />
        <h3
          class="type:h6-large leading-[1.4] text-charcoal line-clamp-2 pt-0.5"
        >
          <span class="hover:underline"
            >{@html post?.content?.previewHeading || post.name}</span
          >
        </h3>

        {#if post?.content?.previewTeaser?.length > 0}
          <div class="type:body-medium text-[#4B4B4B] line-clamp-1">
            {post.content.previewTeaser}
          </div>
        {/if}

        <!-- {#if hovered}
					<div transition:slide|global={{  duration: 300, easing: quintOut, axis: 'x' }}>
						<ArrowLink class="reduced hover-red-bg"></ArrowLink>
					</div>
				{/if} -->
      </div>

      <div class="sm:max-w-[31%] w-full hidden sm:block">
        <div
          class="aspect-[384/202] w-full rounded-[5px] overflow-hidden group-hover:opacity-90 transition-opacity duration-300"
        >
          {#if post?.content?.mastheadImage?.filename}
            <img
              src={resizeImage(post.content.mastheadImage.filename)}
              alt={post.content.mastheadImage.alt}
              class="w-full h-full object-cover"
              style={aspectRatio(post.content.mastheadImage.filename)}
              loading="lazy"
            />
          {/if}
        </div>
      </div>
    </a>
  </div>
{/if}
